import { render, staticRenderFns } from "./FactData.vue?vue&type=template&id=51e311f5&"
import script from "./FactData.vue?vue&type=script&lang=js&"
export * from "./FactData.vue?vue&type=script&lang=js&"
import style0 from "./FactData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VRow,VSpacer})
